import { render, staticRenderFns } from "./DynamicTabsPagination.vue?vue&type=template&id=c1188c2e&"
import script from "./DynamicTabsPagination.vue?vue&type=script&lang=js&"
export * from "./DynamicTabsPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy/projects/magculture/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1188c2e')) {
      api.createRecord('c1188c2e', component.options)
    } else {
      api.reload('c1188c2e', component.options)
    }
    module.hot.accept("./DynamicTabsPagination.vue?vue&type=template&id=c1188c2e&", function () {
      api.rerender('c1188c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/DynamicTabs/DynamicTabsPagination.vue"
export default component.exports